import React from 'react'
import { useDispatch } from 'react-redux'
import { deleteArticle, getVolumes } from '../../../../entity/volumes/Volumes'
import { MdOutlineDelete } from 'react-icons/md'

const DeleteArticle = ({ articleId }) => {
  const dispatch = useDispatch()

  const deleteHandler = async () => {
    const confirmed = window.confirm('Do you want to delete this article?')

    if (confirmed && articleId) {
      await dispatch(deleteArticle(articleId))
      dispatch(getVolumes())
    } else {
      console.log('Delete action canceled')
    }
  }
  return (
    <MdOutlineDelete
      className='hover:cursor-pointer hover:scale-110 transition-all'
      onClick={deleteHandler}
    />
  )
}

export default DeleteArticle
